import { concat, flatten, map, pipe, values } from 'ramda'
import { useMemo, useState } from 'react'
import { createContainer } from 'unstated-next'

import useSwr from '../../../hooks/use-swr'
import eventsSort from '../../../utils/events-sort'

const uniqid = require('uniqid')

const ArtistInfoStore = createContainer((initialData) => {
  const [livdemyId, updateLivdemyId] = useState('')

  const { data, error } = useSwr({
    condition: Boolean(livdemyId),
    initialData,
    server: 'public-cache',
    url: `teacher/profile/${livdemyId}`,
  })

  const classes = useMemo(
    () =>
      pipe(
        values,
        flatten,
        eventsSort,
        concat(data?.recordedCourses || []),
        concat(data?.liveCourses || []),
        map((item) => ({
          ...item,
          endTime: 0,
          id: item.id || uniqid(),
          startTime: 0,
        })),
      )(data?.broadcastClasses || {}),
    [data],
  )

  return {
    classes,
    data,
    livdemyId,
    loadFailed: Boolean(error) && !data,
    loading: !data && !error,
    updateLivdemyId,
  }
})

export default ArtistInfoStore
